import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/crazysal/sit-a/bd-mobile-next/app/components/article/ArticleTemplate.tsx");
